import { useState } from "react";

const CATEGORIES = [
  {
    id: "triply",
    label: "Tri-Ply Cookware",
    icon: "fa-cutlery",
    tag: "10 Variants",
    material: "SS304 + Aluminium + SS430",
    thickness: "2.5mm",
    compatibility: "Gas & Induction",
    products: [
      {
        code: "UTC-101",
        name: "Honeycomb Tri-Ply Kadhai",
        variant: "SS Wire Handle",
        sizes: "20–30 cm",
        feature: "Laser Etched Honeycomb Surface",
      },
      {
        code: "UTC-102",
        name: "Honeycomb Tri-Ply Kadhai",
        variant: "Silicone Handle",
        sizes: "20–30 cm",
        feature: "Cool Touch Silicone Grip",
      },
      {
        code: "UTC-103",
        name: "Tri-Ply Kadhai",
        variant: "With SS Lid",
        sizes: "20–30 cm",
        feature: "Stainless Steel Riveted Handle",
      },
      {
        code: "UTC-104",
        name: "Honeycomb Fry Pan",
        variant: "Silicone Handle",
        sizes: "20–26 cm",
        feature: "Honeycomb Inner Coating",
      },
      {
        code: "UTC-105",
        name: "Tri-Ply Fry Pan",
        variant: "Silicone Handle",
        sizes: "20–26 cm",
        feature: "Cool Touch Silicone Handle",
      },
      {
        code: "UTC-106",
        name: "Tri-Ply Fry Pan",
        variant: "SS Handle",
        sizes: "20–26 cm",
        feature: "Stainless Steel Handle",
      },
      {
        code: "UTC-107",
        name: "Tri-Ply Tawa",
        variant: "SS Wire Handle",
        sizes: "10–11 Inch",
        feature: "Flat Cooking Surface",
      },
      {
        code: "UTC-108",
        name: "Tri-Ply Tawa",
        variant: "Silicone Handle",
        sizes: "10–11 Inch",
        feature: "Cool Touch Silicone Grip",
      },
      {
        code: "UTC-109",
        name: "Honeycomb Tawa",
        variant: "Heat Resistant Handle",
        sizes: "10–11 Inch",
        feature: "Honeycomb Technology",
      },
      {
        code: "UTC-110",
        name: "Tri-Ply Sauce Pan",
        variant: "SS Handle",
        sizes: "14 / 16 / 18 cm",
        feature: "Spill Resistant Design",
      },
    ],
  },
  {
    id: "iron",
    label: "Iron Cookware",
    icon: "fa-fire",
    tag: "6 Variants",
    material: "Pure Iron",
    thickness: "3mm",
    compatibility: "Gas Stove",
    products: [
      {
        code: "UIC-101",
        name: "Iron Fry Pan",
        variant: "SS Handle",
        sizes: "No. 1–4",
        feature: "Pre-Seasoned / Natural Finish",
      },
      {
        code: "UIC-102",
        name: "Iron Kadhai",
        variant: "SS Handle",
        sizes: "22–30 cm",
        feature: "Deep Kadhai Design",
      },
      {
        code: "UIC-103",
        name: "Iron Tadka Pan - Round Base",
        variant: "SS Handle",
        sizes: "No. 1–3",
        feature: "Compact Tempering Design",
      },
      {
        code: "UIC-104",
        name: "Iron Tawa",
        variant: "SS Wire Handle",
        sizes: "9–12 Inch",
        feature: "Flat Even Heat Distribution",
      },
      {
        code: "UIC-105",
        name: "Iron Tawa",
        variant: "Wooden Handle",
        sizes: "10–12 Inch",
        feature: "Wide Flat Surface",
      },
      {
        code: "UIC-106",
        name: "Iron Dosa Tawa — Flat Handle",
        variant: "SS Handle",
        sizes: "22–30 cm",
        feature: "Stainless Steel Flat Handle",
      },
    ],
  },
  {
    id: "cookers",
    label: "Pressure Cookers",
    icon: "fa-tachometer",
    tag: "4 Types",
    material: "SS304 / Hard Anodized / Aluminium",
    thickness: "2.5mm – 5mm",
    compatibility: "Gas & Induction",
    products: [
      {
        code: "UPC-101",
        name: "Tri-Ply Pressure Cooker",
        variant: "SS304 + Alu + SS430 | Mirror Finish",
        sizes: "2L / 3L / 5L",
        feature: "Full Induction Bottom | Inner Lid",
      },
      {
        code: "UPC-102",
        name: "Stainless Steel Pressure Cooker",
        variant: "Food Grade SS304 | 5mm Sandwich Base",
        sizes: "2L / 3L / 5L",
        feature: "Rust Resistant | Inner Lid",
      },
      {
        code: "UPC-103",
        name: "Hard Anodized Pressure Cooker",
        variant: "3.25mm Hard Anodized | Black Finish",
        sizes: "2L / 3L / 5L",
        feature: "Non-Reactive | Scratch Resistant",
      },
      {
        code: "UPC-104",
        name: "Aluminium Pressure Cooker",
        variant: "Virgin Food Grade Aluminium | Mirror Polish",
        sizes: "2L / 3L / 5L",
        feature: "Fast Heating | Budget Friendly",
      },
    ],
  },
  {
    id: "gasstoves",
    label: "Gas Stoves",
    icon: "fa-home",
    tag: "10 Models",
    material: "Toughened Glass / Stainless Steel",
    thickness: "7mm Glass",
    compatibility: "LPG Compatible",
    products: [
      {
        code: "UGT-101",
        name: "Gas Stove GT-301",
        variant: "3 Burner | Black Glass",
        sizes: "3 Burner",
        feature: "High Efficiency Brass Burner",
      },
      {
        code: "UGT-102",
        name: "Gas Stove GT-302",
        variant: "3 Burner | Black Glass",
        sizes: "3 Burner",
        feature: "Blue Flame Technology",
      },
      {
        code: "UGT-103",
        name: "Gas Stove GT-303",
        variant: "3 Burner | Grey Glass",
        sizes: "3 Burner",
        feature: "Grey Glass | 1 Year Warranty",
      },
      {
        code: "UGT-104",
        name: "Gas Stove GT-304",
        variant: "3 Burner | Grey Glass",
        sizes: "3 Burner",
        feature: "Grey Glass | 1 Year Warranty",
      },
      {
        code: "UGT-105",
        name: "Gas Stove GT-401",
        variant: "4 Burner | Black Glass",
        sizes: "4 Burner",
        feature: "4 Burner Heavy Cast Iron Support",
      },
      {
        code: "USS-101",
        name: "Gas Stove SS-201",
        variant: "2 Burner | Flat SS",
        sizes: "2 Burner",
        feature: "Chrome Knobs | LPG Compatible",
      },
      {
        code: "USS-102",
        name: "Gas Stove SS-202",
        variant: "2 Burner | T-Shaped",
        sizes: "2 Burner",
        feature: "T-Shaped Cast Iron Pan Support",
      },
      {
        code: "USS-103",
        name: "Gas Stove SS-301",
        variant: "3 Burner | Flat SS",
        sizes: "3 Burner",
        feature: "Flat SS Body | Chrome Knobs",
      },
      {
        code: "USS-104",
        name: "Gas Stove SS-302",
        variant: "3 Burner | Mirror Polish",
        sizes: "3 Burner",
        feature: "Mirror Polish Finish",
      },
      {
        code: "USS-105",
        name: "Gas Stove SS-303",
        variant: "3 Burner | Rounded SS",
        sizes: "3 Burner",
        feature: "Rounded Body | ABS Knobs",
      },
    ],
  },
];

export const Products = () => {
  const [active, setActive] = useState("triply");
  const cat = CATEGORIES.find((c) => c.id === active);

  return (
    <div id="products" className="products-section">
      <div className="container">
        <div className="section-title">
          <h2>Current Product Portfolio</h2>
          <p>
            Our current range covers 30+ variants across cookware, kitchenware,
            pressure cookers and gas stoves — with expansion planned into home
            appliances, household products and other consumer categories.
          </p>
        </div>

        <div className="prod-tabs">
          {CATEGORIES.map((c) => (
            <button
              key={c.id}
              className={`prod-tab${active === c.id ? " active" : ""}`}
              onClick={() => setActive(c.id)}
            >
              <i className={`fa ${c.icon}`}></i>
              <span>{c.label}</span>
              <small>{c.tag}</small>
            </button>
          ))}
        </div>

        <div className="prod-spec-bar">
          <div className="prod-spec-item">
            <i className="fa fa-flask"></i>
            <span>
              <strong>Material:</strong> {cat.material}
            </span>
          </div>
          <div className="prod-spec-item">
            <i className="fa fa-arrows-v"></i>
            <span>
              <strong>Grade:</strong> {cat.thickness}
            </span>
          </div>
          <div className="prod-spec-item">
            <i className="fa fa-fire"></i>
            <span>
              <strong>Compatible:</strong> {cat.compatibility}
            </span>
          </div>
          <div className="prod-spec-item prod-oem-badge">
            <i className="fa fa-cogs"></i>
            <span>Bulk / OEM / Export Available</span>
          </div>
        </div>

        <div className="row prod-grid">
          {cat.products.map((p) => (
            <div key={p.code} className="col-md-4 col-sm-6">
              <div className="prod-card">
                <div className="prod-card-header">
                  <span className="prod-code">{p.code}</span>
                  <span className="prod-oem-tag">Bulk ✓</span>
                </div>
                <h4 className="prod-name">{p.name}</h4>
                <p className="prod-variant">{p.variant}</p>
                <div className="prod-specs-mini">
                  <i className="fa fa-arrows-h"></i> {p.sizes}
                </div>
                <div className="prod-feature">
                  <i className="fa fa-star"></i> {p.feature}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="products-expansion-note">
          <i className="fa fa-rocket"></i>
          <div>
            <strong>Expanding Soon</strong>
            <p>
              Mixer Grinders · Juicers · Induction Cooktops · Electric Kettles ·
              Small Home Appliances · Household Products · Cleaning Solutions ·
              Storage Products
            </p>
          </div>
        </div>

        <div className="prod-cta-row">
          <a
            href="/PDF/Utensy Product Catalogue 2026.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-custom"
          >
            <i className="fa fa-download"></i>&nbsp; Download Catalogue (PDF)
          </a>
          <a href="#contact" className="btn btn-outline-dark page-scroll">
            <i className="fa fa-envelope-o"></i>&nbsp; Bulk / OEM / Export
            Enquiry
          </a>
        </div>
      </div>
    </div>
  );
};
